module.exports = __webpack_public_path__ + "static/media/play-white.9b171336.svg";